namespace TabAurous.Inventory {
    export interface StockEnquiryForm {
        ProductCode: Serenity.StringEditor;
        ProductName: Serenity.StringEditor;
        ProductTypeName: Serenity.StringEditor;
        ItemType: Serenity.LookupEditor;
        CategoryName: Serenity.StringEditor;
        SubCategoryName: Serenity.StringEditor;
        BrandName: Serenity.StringEditor;
        CollectionName: Serenity.StringEditor;
        SuperTypeName: Serenity.StringEditor;
        MetalName: Serenity.StringEditor;
        KaratName: Serenity.StringEditor;
        MetalColorName: Serenity.StringEditor;
        StoneSizeName: Serenity.StringEditor;
        SieveName: Serenity.StringEditor;
        StoneColoreName: Serenity.StringEditor;
        QualityName: Serenity.StringEditor;
        ShapeName: Serenity.StringEditor;
        Purity: Serenity.DecimalEditor;
        PureWeight: Serenity.DecimalEditor;
        CalcOnId: Serenity.IntegerEditor;
        Line_No: Serenity.StringEditor;
        LotNo: Serenity.StringEditor;
        SKU: Serenity.StringEditor;
        DeptName: Serenity.StringEditor;
        Pieces: Serenity.IntegerEditor;
        Weight: Serenity.DecimalEditor;
        NetWeight: Serenity.DecimalEditor;
        DiamondPieces: Serenity.IntegerEditor;
        DiamondWeight: Serenity.DecimalEditor;
        StonePieces: Serenity.IntegerEditor;
        StoneWeight: Serenity.DecimalEditor;
        MF: Serenity.DecimalEditor;
        MFAmount: Serenity.DecimalEditor;
        ImageName: Serenity.ImageUploadEditor;
        Image1: Serenity.ImageUploadEditor;
        BOMDetails: Stock.StockEnquiryBOMEditor;
        BOMCategoryName: Serenity.StringEditor;
        BOMSubCategoryName: Serenity.StringEditor;
        BOMStoneColoreName: Serenity.StringEditor;
        BOMQualityName: Serenity.StringEditor;
        BOMShapeName: Serenity.StringEditor;
        BOMMetalColorName: Serenity.StringEditor;
        BOMKaratName: Serenity.StringEditor;
        BOMPurity: Serenity.DecimalEditor;
        BOMPureWeight: Serenity.DecimalEditor;
        BOMStoneSizeName: Serenity.StringEditor;
        BOMSieveName: Serenity.StringEditor;
        BOMGroupSieveName: Serenity.StringEditor;
        BomRate: Serenity.DecimalEditor;
        BomAmount: Serenity.DecimalEditor;
        HistoryDetails: Stock.StockEnquiryHistoryEditor;
    }

    export class StockEnquiryForm extends Serenity.PrefixedContext {
        static formKey = 'Inventory.StockEnquiry';
        private static init: boolean;

        constructor(prefix: string) {
            super(prefix);

            if (!StockEnquiryForm.init)  {
                StockEnquiryForm.init = true;

                var s = Serenity;
                var w0 = s.StringEditor;
                var w1 = s.LookupEditor;
                var w2 = s.DecimalEditor;
                var w3 = s.IntegerEditor;
                var w4 = s.ImageUploadEditor;
                var w5 = Stock.StockEnquiryBOMEditor;
                var w6 = Stock.StockEnquiryHistoryEditor;

                Q.initFormType(StockEnquiryForm, [
                    'ProductCode', w0,
                    'ProductName', w0,
                    'ProductTypeName', w0,
                    'ItemType', w1,
                    'CategoryName', w0,
                    'SubCategoryName', w0,
                    'BrandName', w0,
                    'CollectionName', w0,
                    'SuperTypeName', w0,
                    'MetalName', w0,
                    'KaratName', w0,
                    'MetalColorName', w0,
                    'StoneSizeName', w0,
                    'SieveName', w0,
                    'StoneColoreName', w0,
                    'QualityName', w0,
                    'ShapeName', w0,
                    'Purity', w2,
                    'PureWeight', w2,
                    'CalcOnId', w3,
                    'Line_No', w0,
                    'LotNo', w0,
                    'SKU', w0,
                    'DeptName', w0,
                    'Pieces', w3,
                    'Weight', w2,
                    'NetWeight', w2,
                    'DiamondPieces', w3,
                    'DiamondWeight', w2,
                    'StonePieces', w3,
                    'StoneWeight', w2,
                    'MF', w2,
                    'MFAmount', w2,
                    'ImageName', w4,
                    'Image1', w4,
                    'BOMDetails', w5,
                    'BOMCategoryName', w0,
                    'BOMSubCategoryName', w0,
                    'BOMStoneColoreName', w0,
                    'BOMQualityName', w0,
                    'BOMShapeName', w0,
                    'BOMMetalColorName', w0,
                    'BOMKaratName', w0,
                    'BOMPurity', w2,
                    'BOMPureWeight', w2,
                    'BOMStoneSizeName', w0,
                    'BOMSieveName', w0,
                    'BOMGroupSieveName', w0,
                    'BomRate', w2,
                    'BomAmount', w2,
                    'HistoryDetails', w6
                ]);
            }
        }
    }
}
